import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=2227fd33&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports